<script setup>
const { isLoading } = useAppState();

const zIndex = ref(2000);
const gamaBall = ref(null);

if (import.meta.client) {
    watchEffect(() => {
        if (!isLoading.value) zIndex.value = 500;
    });

    watch(isLoading, (newVal) => {
        if (newVal) {
            if (gamaBall.value?.ballRef) gamaBall.value.ballRef.play();
        } else {
            if (gamaBall.value?.ballRef) gamaBall.value.ballRef.pause();
        }
    });
}
</script>

<template>
    <div
        id="loading-frame"
        :style="{ zIndex: zIndex }"
        class="fixed left-0 top-0 h-full w-full overflow-hidden bg-base-bgGrey"
        :class="{
            'slt-loading-fade -translate-y-full': !isLoading,
        }"
    >
        <div
            class="absolute left-1/2 top-1/2 z-[5] h-[23.66vw] w-[23.66vw] -translate-x-1/2 -translate-y-1/2 xs:h-[93px] xs:w-[93px] sm:h-[124px] sm:w-[124px] lg:h-[8.2vw] lg:max-h-[124px] lg:w-[8.2vw] lg:max-w-[124px]"
            :class="{
                'slt-drop translate-y-[calc(var(--window-height)/2)] scale-[0.5]':
                    !isLoading,
            }"
        >
            <div
                class="absolute left-[4.5%] top-[4.5%] h-[91%] w-[91%] rounded-full bg-primary-orange"
            ></div>
            <GamaGlobeLottie ref="gamaBall" class="h-full w-full" :speed="2" />
        </div>
        <div
            class="slt-display-1 absolute bottom-[8.14vw] left-0 right-0 w-full overflow-x-hidden text-center text-base-silver xs:bottom-[32px] sm:bottom-[48px] lg:bottom-[1.59vw] xl:bottom-[16px] 3xl:text-[215.8px] 3xl:tracking-[-12.86px]"
            :class="{
                'slt-drop translate-y-[calc(var(--window-height)/4)]':
                    !isLoading,
            }"
        >
            <div class="flex flex-nowrap" :class="{ 'stop-marquee': !isLoading }">
                <span class="slt-marquee">Loading...&nbsp;</span>
                <span class="slt-marquee">Loading...&nbsp;</span>
                <span class="slt-marquee">Loading...&nbsp;</span>
                <span class="slt-marquee">Loading...&nbsp;</span>
                <span class="slt-marquee">Loading...&nbsp;</span>
            </div>
        </div>
        <div
            class="absolute left-0 top-0 h-full w-full bg-primary-orange transition-transform ease-in-out-cubic"
            :class="{
                'translate-y-full duration-0': isLoading,
                'delay-300 duration-500': !isLoading,
            }"
        ></div>
    </div>
</template>

<style scoped>
.slt-loading-fade {
    transition: transform 0.7s 0.8s cubic-bezier(0.76, 0, 0.24, 1);
}

.slt-drop {
    transition: transform 1s cubic-bezier(0.68, -0.6, 0.32, 1.6);
}

/* Loading Frame Marquee */

.slt-marquee {
    @apply inline-block shrink-0 animate-[marquee_8s_linear_infinite] leading-[1.2];
    animation-play-state: running;
}

.stop-marquee .slt-marquee {
    animation-play-state: paused;
}

@keyframes marquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}
</style>
